import React, { FC } from 'react';
import { Box, Link, Typography } from '@mui/material';
import { get } from 'lodash';
import SummaryLine from '../../../ui-component/form-component/abschluss-page/SummaryLine';
// import { enumT } from '../../../../utils/helper';
import { PAGES_URLS } from '../../../../lib/constants/routes';

import PersonSchema from '../../../../lib/paths/person_FULL_Paths.json';
import OrgaSchema from '../../../../lib/paths/unternehmen_FULL_Paths.json'
import UserSchema from '../../../../lib/paths/user_Paths.json';
import CreateForm from '../../../ui-component/form-component/create-form/CreateForm';
const PP = PersonSchema.attributes;
const OP = OrgaSchema.attributes;
const UP = UserSchema.attributes;

const AbschlussRegistrierung: FC<{
	formValue: any;
	updateFunction: (_key: string, _value: any) => void;
	personDaten: any;
	organisationDaten: any;
	LoginDaten: any;
}> = ({ formValue, updateFunction, personDaten, organisationDaten, LoginDaten }) => {
	return (
		<>
			<Typography variant="h5"> Abschluss</Typography>

			<Box sx={{ mt: '2rem' }}>
				<Typography variant="h6">Persondaten</Typography>
				{/* <SummaryLine
					label="Anrede"
					value={enumT(get(personDaten, PP.Personenbezogene_Daten_Anrede.path, '-'))}
					showErrorMessagePlaceholder={false}
				/> */}
				<SummaryLine
					label="Titel"
					value={get(personDaten, PP.Personenbezogene_Daten_Titel.path, '-')}
					showErrorMessagePlaceholder={false}
				/>
				<SummaryLine
					label="Vorname"
					value={get(personDaten, PP.Personenbezogene_Daten_Vorname.path, '')}
					showErrorMessagePlaceholder={false}
				/>
				<SummaryLine
					label="Nachname"
					value={get(personDaten, PP.Personenbezogene_Daten_Nachname.path, '')}
					showErrorMessagePlaceholder={false}
				/>
				{/* <SummaryLine
					label="Rolle"
					value={enumT(get(personDaten, PP.Personenbezogene_Daten_Rolle.path, '-'))}
					showErrorMessagePlaceholder={false}
				/> */}
				<SummaryLine
					label="E-Mail - Die Passwortvergabe wird an diese Adresse gesendet"
					value={get(personDaten, PP.Kontaktdaten_E_Mail.path, '')}
					showErrorMessagePlaceholder={false}
				/>

				<SummaryLine
					label="Telefon"
					value={get(personDaten, PP.Kontaktdaten_Telefon.path, '')}
					showErrorMessagePlaceholder={false}
				/>
			</Box>

			<Box sx={{ mt: '2rem' }}>
				<Typography variant="h6">Organisationsdaten</Typography>

				{/* <SummaryLine
					label="USt-IdNr."
					value={get(organisationDaten, OP.Unternehmensprofil_U_St_Id_Nr.path)}
					showErrorMessagePlaceholder={false}
				/> */}
				<SummaryLine
					label="Rechtverbindlicher Name der Organisation"
					value={get(organisationDaten, OP.Geschaeftsbezogene_Daten_Name_Der_Organisation.path)}
					showErrorMessagePlaceholder={false}
				/>

				{/* <SummaryLine
					label="Rechtform der Organisation"
					value={enumT(get(organisationDaten, OP.Geschaeftsbezogene_Daten_Rechtsform_Der_Organisation.path))}
					showErrorMessagePlaceholder={false}
				/> */}

				{/* <SummaryLine
					label="Institutionstyp"
					value={enumT(get(organisationDaten, OP.Geschaeftsbezogene_Daten_Institutionstyp.path))}
					showErrorMessagePlaceholder={false}
				/> */}
				{/* <SummaryLine
					label="Straße und Hausnummer"
					value={get(organisationDaten, OP.Adressdaten_Strasse_Und_Hausnummer.path)}
					showErrorMessagePlaceholder={false}
				/> */}
				<SummaryLine
					label="Postleitzahl, Ort"
					value={get(organisationDaten, OP.Adressdaten_PLZ.path) + ', ' + get(organisationDaten, OP.Adressdaten_Ort.path)}
					showErrorMessagePlaceholder={false}
				/>
				<SummaryLine
					label="E-Mail-Adresse"
					value={get(organisationDaten, OP.Kontaktdaten_E_Mail.path)}
					showErrorMessagePlaceholder={false}
				/>
				<SummaryLine
					label="Telefon"
					value={get(organisationDaten, OP.Kontaktdaten_Telefon.path)}
					showErrorMessagePlaceholder={false}
				/>
			</Box>

			<Box sx={{ mt: '2rem', mb: '2rem' }}>
				<Typography variant="h6">Logindaten</Typography>
				<SummaryLine label="Benutzername" value={get(LoginDaten, UP.username.path)} showErrorMessagePlaceholder={false} />
			</Box>

			<Typography variant="h6" sx={{ fontWeight: 600 }}>
				Zustimmung zu den Nutzungsbedingungen:
			</Typography>
			<Typography>
				Lesen Sie die{' '}
				<Link target="_blank" href={PAGES_URLS.Datenschutz}>
					{' '}
					Nutzungsbedingungen und Datenschutzrichtlinien{' '}
				</Link>{' '}
				sorgfältig durch. Um fortzufahren, bestätigen Sie Ihre Zustimmung durch das Setzen eines Häkchens
			</Typography>

			<CreateForm formValues={formValue} formStruc={formStrucDatenschutz()} updateFormValuesFunc={updateFunction} />
		</>
	);
};

export default AbschlussRegistrierung;
const formStrucDatenschutz = () => {
	return [
		{
			fields: [
				{
					path: 'zustimmung',
					type: 'boolean',
					label: `Ich habe die Nutzungsbedingungen und die Datenschutzrichtlinien gelesen und akzeptiere diese.`,
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
};
